export default __webpack_public_path__ + "static/media/ASBM 6 Wheel.795321b7.jpg";